// 이미지를 data url로 변환
const fileToDataUrl = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(file)
  })
}

export const postProposal = async (email: string, content: string, type: string, image: File | null) => {
  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL

  const dataUrls: string[] = image ? [await fileToDataUrl(image)] : []

  const response = await fetch(`${baseUrl}/api/v1/proposals`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      proposal: {
        inquiry_type: type,
        data_urls: dataUrls,
        email,
        content
      }
    })
  })
  return response
}